import styled from "styled-components";

import { Icon } from "@formant/ui/component/common/Icon";
import { distance } from "@formant/ui/component/common/Spacing";

const getBackgroundColor = (filtering: boolean) =>
    filtering
        ? `var(--color-background-primary)`
        : `var(--color-background-tertiary)`;

// FIXME there are two sets of breakpoints: utils/breakpoints and common.scss and they dont match.
export const mobileBreakpoint = `(max-width: 46.875rem)`;

export const TabsContainer = styled.nav`
    width: 100%;
    overflow: hidden;
    position: relative;
`;

export const TabsContainerScroll = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 0;
    width: 100%;
    height: 42px;

    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        display: none;
    }

    @media ${mobileBreakpoint} {
        margin-inline-start: 1rem;
    }
`;

export const StyledTab = styled.div<{
    $selected: boolean;
    $filtering: boolean;
    $dragging: boolean;
}>`
    touch-action: none;
    font-size: 0.8125rem;
    display: flex;
    align-items: stretch;
    gap: 0.25rem;

    opacity: ${props => (props.$dragging ? "0" : "unset")};
    position: ${props =>
        props.$selected && !props.$dragging ? "sticky" : "relative"};
    z-index: ${props => (props.$selected && !props.$dragging ? "2" : "auto")};
    color: ${props =>
        props.$selected
            ? "var(--color-text-primary)"
            : "var( --color-text-secondary)"};

    left: 0;
    right: 0;

    background-color: ${props => getBackgroundColor(props.$filtering)};
    box-shadow: 0 0 1rem 1rem ${props => getBackgroundColor(props.$filtering)};

    border-bottom-style: solid;
    border-bottom-color: var(--color-border-active);
    border-bottom-width: ${props => (props.$selected ? "0.125rem" : "0")};

    @media ${mobileBreakpoint} {
        ${props => (!props.$selected ? `display: none` : null)};
    }

    margin-inline: 0.75rem;

    &:first-of-type {
        margin-inline-start: 0;
    }

    &:last-of-type {
        margin-inline-end: 0;
    }
`;

const ButtonReset = styled.button`
    all: unset;
    cursor: pointer;
    box-sizing: border-box;
`;

const SharedButton = styled(ButtonReset)`
    height: 2.5rem;
    display: flex;
    align-items: center;
`;

export const SelectTabButton = styled(SharedButton)<{
    $saving: boolean;
    $floating: boolean;
}>`
    gap: 0.25rem;
    color: var(--color-text-primary);
    white-space: nowrap;
    cursor: ${props =>
        props.$saving ? "no-drop" : props.$floating ? "grabbing" : "pointer"};
`;

export const DropdownButton = styled(SharedButton)``;

export const DropdownIcon = styled(Icon)`
    position: relative;
    transition:
        top 200ms,
        color 200ms;
    top: 0;
    &:hover {
        top: ${distance(2)};
        svg {
            fill: var(--color-text-primary);
        }
    }
`;

export const TabActionButton = styled(ButtonReset)`
    margin-block: 0.25rem;
    aspect-ratio: 1 / 1;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    &:hover {
        background-color: var(--color-action-quaternary);
    }
`;

export const AddActionButton = styled(TabActionButton)`
    margin-inline-start: ${distance(10)};
`;
export const OverflowActionButton = styled(TabActionButton)`
    margin-inline: ${distance(2)};
`;

const OverflowCommon = styled.span<{ $filtering: boolean }>`
    align-self: stretch;
    display: block;
    flex-shrink: 0;
    left: 0;
    position: sticky;
    right: 0;
    pointer-events: none;
    width: 1rem;
    z-index: 1;

    opacity: ${props => (props.$filtering ? 0 : 1)};

    transition: opacity 200ms ease-in-out 0ms;
    @media ${mobileBreakpoint} {
        display: none;
    }
`;

export const Overflow = {
    LEFT: styled(OverflowCommon)`
        position: absolute;
        height: 100%;
        top: 0;
        right: unset;
        background: linear-gradient(
            90deg,
            var(--color-background-tertiary),
            transparent
        );
    `,
    RIGHT: styled(OverflowCommon)`
        position: absolute;
        height: 100%;
        top: 0;
        left: unset;
        background: linear-gradient(
            -90deg,
            var(--color-background-tertiary),
            transparent
        );
    `,
};
